import { render, staticRenderFns } from "./SubscriptionTag.vue?vue&type=template&id=81455336&scoped=true&"
import script from "./SubscriptionTag.vue?vue&type=script&lang=js&"
export * from "./SubscriptionTag.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionTag.vue?vue&type=style&index=0&id=81455336&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81455336",
  null
  
)

export default component.exports